import { render, staticRenderFns } from "./ColorPickerMulti.vue?vue&type=template&id=482c189e&"
import script from "./ColorPickerMulti.vue?vue&type=script&lang=js&"
export * from "./ColorPickerMulti.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerMulti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports